import { ref } from 'vue';
import { $api } from '@/services';
import { isLitePackage } from '@/helper/packageTier';
import { useStore } from 'vuex';
const error = ref(null);
const loading = ref(false);
const store = useStore();

function getIsLitePackage() {
	return isLitePackage(store.state.profile);
}

export async function getBoardings() {
	if (getIsLitePackage()) return;
	error.value = null;
	try {
		const res = await $api.boarding.getDayCareClasses();
		return res?.data;
	} catch (err) {
		error.value = err?.response?.data?.errors || err.message;
	} finally {
		loading.value = false;
	}
}

export function useGetBoardings() {
	return { error, loading, getBoardings };
}
